'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./table-cell.css');

var _ = require('../../../');

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoTableCell = function (_Component) {
    _inherits(GeckoTableCell, _Component);

    function GeckoTableCell() {
        var _ref, _this$types;

        var _temp, _this, _ret;

        _classCallCheck(this, GeckoTableCell);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoTableCell.__proto__ || Object.getPrototypeOf(GeckoTableCell)).call.apply(_ref, [this].concat(args))), _this), _this.types = (_this$types = {}, _defineProperty(_this$types, _.GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM, _types.GeckoTableCellCustom), _defineProperty(_this$types, _.GECKO_CONSTS.TABLE_CELL_TYPE_CURRENCY, _types.GeckoTableCellDefault), _defineProperty(_this$types, _.GECKO_CONSTS.TABLE_CELL_TYPE_DATE, _types.GeckoTableCellDate), _defineProperty(_this$types, _.GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT, _types.GeckoTableCellDefault), _defineProperty(_this$types, _.GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN, _types.GeckoTableCellDropdown), _defineProperty(_this$types, _.GECKO_CONSTS.TABLE_CELL_TYPE_NAME, _types.GeckoTableCellName), _defineProperty(_this$types, _.GECKO_CONSTS.TABLE_CELL_TYPE_STATUS, _types.GeckoTableCellStatus), _this$types), _temp), _possibleConstructorReturn(_this, _ret);
    }

    // Map cell types to cell components


    _createClass(GeckoTableCell, [{
        key: 'col',


        // Get col
        value: function col() {
            return this.props.col;
        }

        // Defaults to 'default'

    }, {
        key: 'type',
        value: function type() {
            return this.col().type || _.GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT;
        }
    }, {
        key: 'renderClasses',
        value: function renderClasses(th) {
            var _GECKO_UTILS$classNam;

            return _.GECKO_UTILS.classNames((_GECKO_UTILS$classNam = {}, _defineProperty(_GECKO_UTILS$classNam, _.GECKO_UTILS.prepareIndexClass('gecko-table-cell', this.props.colIndex), true), _defineProperty(_GECKO_UTILS$classNam, _.GECKO_UTILS.prepareNameClass('gecko-table-cell', this.col().key), !th), _defineProperty(_GECKO_UTILS$classNam, _.GECKO_UTILS.prepareNameClass('gecko-table-header-cell', this.col().key), th), _defineProperty(_GECKO_UTILS$classNam, 'gecko-table-header-cell', th), _defineProperty(_GECKO_UTILS$classNam, 'gecko-table-cell', !th), _defineProperty(_GECKO_UTILS$classNam, 'gecko-table-cell-type-' + this.type(), true), _defineProperty(_GECKO_UTILS$classNam, this.col().class, this.col().class), _defineProperty(_GECKO_UTILS$classNam, 'text-left', this.col().align === 'left'), _defineProperty(_GECKO_UTILS$classNam, 'text-center', this.col().align === 'center'), _defineProperty(_GECKO_UTILS$classNam, 'text-right', this.col().align === 'right'), _GECKO_UTILS$classNam));
        }
    }, {
        key: 'renderStyles',
        value: function renderStyles() {
            var styles = {};

            // Apply cell width value
            if (this.col().width) {
                styles.width = this.col().width;
            }

            return styles;
        }
    }, {
        key: 'renderCell',
        value: function renderCell() {
            var Cell = this.types[this.type()];
            return _react2.default.createElement(Cell, { row: this.props.row, col: this.col(), index: this.props.index });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'td',
                { className: this.renderClasses(), style: this.renderStyles() },
                this.renderCell()
            );
        }
    }]);

    return GeckoTableCell;
}(_react.Component);

GeckoTableCell.defaultProps = {
    col: {},
    row: {}
};

GeckoTableCell.propTypes = {
    col: _propTypes2.default.shape(_.GeckoTableCellModel).isRequired,
    row: _propTypes2.default.object
};

exports.default = GeckoTableCell;
